<template>
  <v-card class="mx-auto" max-width="600" elevation="0">
    <v-card-text class="py-0">
      <v-timeline align-top dense>
        <v-timeline-item color="pink" small>
          <v-row class="pt-1" style="overflow-x: auto;flex-wrap: nowrap">
            <v-col cols=10.5>
              <div class="caption">
                <v-chip class="pa-3" text-color="white" :color="getColor()">
                  <div>{{ formatDate(item) }}</div>
                </v-chip>
              </div>
            </v-col>
          </v-row>
        </v-timeline-item>
      </v-timeline>
    </v-card-text>
  </v-card>
</template>
<script>
import { niceDateTimeFormat } from '@/utils/DateFormatter';
export default {
  props: {
    item: String,
  },
  methods: {
    formatDate: function (date) {
      return niceDateTimeFormat(new Date(date));
    },
    getColor() {
      return "green";
    },
  },
};
</script>